import React from 'react'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { Link } from 'react-router-dom'

const ZODIAC_SIGNS = [
    { slug: 'aries', label: 'Aries', image: Common_Images_Transport?.Aries },
    { slug: 'taurus', label: 'Taurus', image: Common_Images_Transport?.Taurus },
    { slug: 'gemini', label: 'Gemini', image: Common_Images_Transport?.Gemini },
    { slug: 'cancer', label: 'Cancer', image: Common_Images_Transport?.Cancer },
    { slug: 'leo', label: 'Leo', image: Common_Images_Transport?.leo },
    { slug: 'virgo', label: 'Virgo', image: Common_Images_Transport?.Virgo },
    { slug: 'libra', label: 'Libra', image: Common_Images_Transport?.Libra },
    { slug: 'scorpio', label: 'Scorpio', image: Common_Images_Transport?.Scorpio },
    { slug: 'sagitarius', label: 'Sagitarius', image: Common_Images_Transport?.Sagitarius },
    { slug: 'capricorn', label: 'Capricorn', image: Common_Images_Transport?.Capricorn },
    { slug: 'aquarius', label: 'Aquarius', image: Common_Images_Transport?.Aquarius },
    { slug: 'pisces', label: 'Pisces', image: Common_Images_Transport?.Piscis },
]

const ZODIAC_DESCRIPTIONS = {
    aries: 'Get ready to rock with unstoppable energy and fierce determination. Your Aries Horoscope is a sneak peek into a year that\'s all about stepping into your power and making your mark.',
    taurus: 'A year of stability and growth awaits you, Taurus. Embrace the opportunities that come your way and build foundations that will last a lifetime.',
    gemini: 'Communication and curiosity are your superpowers this year, Gemini. Your dual nature helps you adapt to any situation and thrive in diverse environments.',
    cancer: 'Emotional intelligence leads you to success, Cancer. Your intuitive nature and deep connections with loved ones will be your greatest assets.',
    leo: 'Shine bright and own the spotlight, Leo. Your natural charisma and leadership qualities will open doors to extraordinary opportunities.',
    virgo: 'Precision and dedication define your year, Virgo. Your analytical mind and attention to detail will help you achieve your most ambitious goals.',
    libra: 'Balance and harmony guide your journey, Libra. Your diplomatic nature and sense of justice will bring meaningful relationships and success.',
    scorpio: 'Transformation is your strength, Scorpio. Your intense focus and resilience will help you navigate challenges and emerge stronger than ever.',
    sagitarius: 'Transformation is your strength, Sagitarius. Your intense focus and resilience will help you navigate challenges and emerge stronger than ever.',
    capricorn: 'Transformation is your strength, Capricorn. Your intense focus and resilience will help you navigate challenges and emerge stronger than ever.',
    aquarius: 'Transformation is your strength, Aquarius. Your intense focus and resilience will help you navigate challenges and emerge stronger than ever.',
    pisces: 'Transformation is your strength, Pisces. Your intense focus and resilience will help you navigate challenges and emerge stronger than ever.',
}

const Similar_Daily_Horoscope = ({ horoscopeType = 'today' }) => {
    return (
        <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-3 mt-4">
            {ZODIAC_SIGNS.map(({ slug, label, image }) => (
                <div key={slug} className="gi-product-content">
                    <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                        <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                            <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                                                <Link
                                    to={`/horoscope-details/${horoscopeType}/${slug}`}
                                    className="image productimg7 relative block overflow-hidden"
                                >
                                    <img
                                        className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                        src={image}
                                        alt={label}
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                            <Link to={`/horoscope-details/${horoscopeType}/${slug}`}>
                                <h5 className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                    {label}
                                </h5>
                            </Link>
                            <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                                {ZODIAC_DESCRIPTIONS[slug]}
                            </p>
                            <div className="gi-pro-rat-price mb-[0] flex flex-col">
                                <Link
                                    to={`/horoscope-details/${horoscopeType}/${slug}`}
                                    className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto"
                                >
                                    View More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Similar_Daily_Horoscope